'use client';

import { useTranslations } from 'next-intl';

import { MenuWrapper } from '../menu-wrapper';
import { SidebarSportsSwitch } from '../sidebar-sports-switch';
import { SidebarSportsMenu, useMenuItemToNavItemMapper } from '../sidebar-sports-menu';
import { SidebarThirdPartyGames } from '../sidebar-third-party-games';
import { SidebarOneSeal } from '../sidebar-one-seal';
import { SidebarMoreItem } from '../sidebar-more-item';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { useState } from 'react';
import { useSportMenuItemGetter } from '@/hooks/query';
import { useSideBarContext } from '../../contexts/sidebar-context';
import { sportService } from '@/services/sport.service';
import { useAccountInfo } from '@/hooks/query/account';
import { galaxySidebarSwitchTabIndexAtom, marsSidebarSwitchTabIndexAtom } from '@/atoms/io';
import { useAtomValue } from 'jotai';
import { GalaxySidebarSwitchTabIndex } from '@/types/nav';
import { useSiteStore } from '@/store/site';
import { sidebarStyle } from '../../sidebar.style';
import clsx from 'clsx';

export const SidebarSports = () => {
	const t = useTranslations('General');
	const { user } = useAccountInfo();
	const view  = useAppearanceStore(state => state.view);
	const [isShowMore, setIsShowMore] = useState(false);
	const isParlayMode = useSiteStore(state => state.isParlayMode);
	const isMarsParlay = view === ViewEnum.mars && isParlayMode;

	const { getSportMenuItemsOfMode } = useSportMenuItemGetter(view === ViewEnum.mars && isParlayMode);
	const menuData = getSportMenuItemsOfMode('M0');
	const selectedCategory = useSideBarContext().selectedCategory;
	const menuItemToNavItemMapper = useMenuItemToNavItemMapper();
	const firstVirtualSoccerIndex = menuData.findIndex(item => parseInt(item.gameId) === 147);
	const sidebarSwitchTabIndex = useAtomValue(view === ViewEnum.galaxy ? galaxySidebarSwitchTabIndexAtom : marsSidebarSwitchTabIndexAtom);
	const isCurrentlyLive = (view === ViewEnum.galaxy && sidebarSwitchTabIndex === GalaxySidebarSwitchTabIndex.Live);
	
	const isShowVirtuallySoccerMenu = (index: number) => (index === firstVirtualSoccerIndex && user?.VirtuallySoccerSportsMenu && !isCurrentlyLive);
	const isShowVirtuallySoccer = (index: number) => (index !== firstVirtualSoccerIndex || !user?.VirtuallySoccerSportsMenu);

	return (
		<MenuWrapper title={view === ViewEnum.galaxy && selectedCategory === 'Sports' ? t('lbl_allsports') : null}>
			{
				selectedCategory !== 'Sports' ? <SidebarThirdPartyGames /> : (
					<>
						<div className={clsx('side-tabs', { [sidebarStyle.sideTabs]: view === ViewEnum.mars })}>
							<SidebarSportsSwitch />
						</div>
						<SidebarSportsMenu data={
							menuData
								.filter((item, index) => {
									const isBetbyBasketball2K = parseInt(item.gameId) === 134;
									if (isMarsParlay && isBetbyBasketball2K) {
										return false;
									}
									return (
										!sportService.isAnyVirtualSportsProduct(parseInt(item.gameId))
										|| isBetbyBasketball2K // Betby Basketball 2K
										|| isShowVirtuallySoccerMenu(index)
									);
								})
								.slice(0, (!isShowMore ? 6 : menuData.length))
								.map(menuItemToNavItemMapper)}
						/>
						{
							menuData.length > 6 && <SidebarMoreItem isShowMore={isShowMore} setIsShowMore={setIsShowMore} />
						}
						{
							view === ViewEnum.galaxy && <div className="side-menu__title">{t('lbl_Others')}</div>
						}
						<SidebarOneSeal virtualSports={menuData
							.filter((item, index) => 
								sportService.isAnyVirtualSportsProduct(parseInt(item.gameId)) && 
								parseInt(item.gameId) !== 134 && // Betby Basketball 2K
								isShowVirtuallySoccer(index)
							)
						}
						/>
					</>
				)
			}
		</MenuWrapper>
	);
};